import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/**
 * The one heading of a screen, with an optional line under it and controls beside it. Every surface uses
 * it, so page titles look the same everywhere. `id` is for the section's `aria-labelledby`.
 */
export function PageHeader({
  title,
  id,
  subtitle,
  actions,
  className,
}: {
  title: ReactNode;
  id?: string;
  subtitle?: ReactNode;
  /** Buttons or a status line, shown to the right; they wrap under the title on a phone. */
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-wrap items-start justify-between gap-x-4 gap-y-2', className)}>
      <div className="flex min-w-0 flex-col gap-1">
        <h1 id={id} className="text-2xl leading-8 font-bold break-words text-ink">
          {title}
        </h1>
        {subtitle && <div className="text-sm text-muted">{subtitle}</div>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
